import React, { useEffect, useState } from "react";
//Bootstrap
import ExpensesTableRows from "./ExpensesTableRows";
//Components
import TableHead from "../TableHead/TableHead";

export default function ExpensesTable({
  expenses,
  setExpenses,
  expenseRows,
  setExpenseRows,
  tableHeads,
  deleteMonth,
}) {
  const [showExpenses, setShowExpenses] = useState(true);

  useEffect(() => {
    var month1 = 0;
    var month2 = 0;
    var month3 = 0;
    var month4 = 0;
    var month5 = 0;
    var month6 = 0;
    var month7 = 0;
    var month8 = 0;
    var month9 = 0;
    var month10 = 0;
    var month11 = 0;
    var month12 = 0;
    expenseRows.map((row) => {
      month1 += Number(row.expenseOne);
      month2 += Number(row.expenseTwo);
      month3 += Number(row.expenseThree);
      month4 += Number(row.expenseFour);
      month5 += Number(row.expenseFive);
      month6 += Number(row.expenseSix);
      month7 += Number(row.expenseSeven);
      month8 += Number(row.expenseEight);
      month9 += Number(row.expenseNine);
      month10 += Number(row.expenseTen);
      month11 += Number(row.expenseEleven);
      month12 += Number(row.expenseTwelve);
    });
    setExpenses({
      month1: month1,
      month2: month2,
      month3: month3,
      month4: month4,
      month5: month5,
      month6: month6,
      month7: month7,
      month8: month8,
      month9: month9,
      month10: month10,
      month11: month11,
      month12: month12,
    });
  }, [expenseRows]);

  const addRow = (id, details) => {
    const randomId = (Math.random() + 1).toString(36).substring(7);

    var newest;
    newest = expenseRows.slice(-1)[0];
    if (details) {
      //then create a blank new row
      if (id === "0e123") {
        if (expenseRows.length) {
        } else {
          const newEntry = {
            id: id,
          };
          setExpenseRows((prev) => {
            return [...prev, newEntry];
          });
        }
      }
    }

    if (!details) {
      //then create a blank new row
      if (id === newest.id) {
        const newEntry = {
          id: randomId,
          title: "",
          expenseOne: 0,
          expenseTwo: 0,
          expenseThree: 0,
          expenseFour: 0,
          expenseFive: 0,
          expenseSix: 0,
          expenseSeven: 0,
          expenseEight: 0,
          expenseNine: 0,
          expenseTen: 0,
          expenseEleven: 0,
          expenseTwelve: 0,
        };
        setExpenseRows((prev) => {
          return [...prev, newEntry];
        });
      }
    }
  };

  const removeRow = (id) => {
    if (expenseRows.length !== 1) {
      setExpenseRows((prev) => {
        return prev.filter((row) => {
          return row.id !== id;
        });
      });
    }
  };

  const setField = (field, id, value) => {
    let current = expenseRows.find((row) => row.id === id);

    if (current) {
      current[field] = value;

      setExpenseRows([...expenseRows]);
    } else {
      const row = {
        [field]: value,
        id: id,
      };
      setExpenseRows([...expenseRows, { row }]);
    }
  };

  const updateShow = () => {
    setShowExpenses(!showExpenses);
  };

  return (
    <div>
      <table className="expensesTable">
        <thead className="expensesTableheadborder">
          <TableHead
            header={"Expenses"}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
            updateShow={updateShow}
            show={showExpenses}
          />
        </thead>
        <tbody className="">
          {showExpenses &&
            expenseRows.map((row) => (
              <ExpensesTableRows
                id={row.id}
                key={row.id}
                row={row}
                addRow={addRow}
                removeRow={removeRow}
                setField={setField}
                expenseRows={expenseRows}
              />
            ))}
        </tbody>
        <tfoot className="foot expensesFoot">
          <tr>
            <td></td>
            <td>{expenses.month1}</td>
            <td>{expenses.month2}</td>
            <td>{expenses.month3}</td>
            <td>{expenses.month4}</td>
            <td>{expenses.month5}</td>
            <td>{expenses.month6}</td>
            <td>{expenses.month7}</td>
            <td>{expenses.month8}</td>
            <td>{expenses.month9}</td>
            <td>{expenses.month10}</td>
            <td>{expenses.month11}</td>
            <td>{expenses.month12}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
